module.exports = __webpack_public_path__ + "media/images/ampoule-icone-29f8d5a43fa3a06ceededd8c2cc3e4af.svg";